import { render, staticRenderFns } from "./UserLocationDialog.vue?vue&type=template&id=2bc316bc&scoped=true"
import script from "./UserLocationDialog.vue?vue&type=script&lang=js"
export * from "./UserLocationDialog.vue?vue&type=script&lang=js"
import style0 from "./UserLocationDialog.vue?vue&type=style&index=0&id=2bc316bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc316bc",
  null
  
)

export default component.exports